import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  NbMenuModule,
  NbSidebarModule,
  NbThemeModule,
  DEFAULT_MEDIA_BREAKPOINTS,
  NbLayoutDirection,
  NbLayoutModule,
  NbIconModule,
  NbSelectModule,
} from "@nebular/theme";

import { HeaderComponent } from "./components";
import { OneColumnLayoutComponent } from "./layouts";
import { DARK_THEME } from "./styles/theme.dark";
import { ExchangeDollarToIQDPipe } from "./pipes/exchange-dollar-to-iqd.pipe";
import { ExchangeIQDToDollarPipe } from "./pipes/exchange-iqdto-dollar.pipe";
import { CurrencySignPipe } from "./pipes/currency-sign.pipe";

const NB_MODULES = [
  NbMenuModule,
  NbSidebarModule,
  NbLayoutModule,
  NbIconModule,
  NbSelectModule,
];
const COMPONENTS = [HeaderComponent, OneColumnLayoutComponent];

const PIPES = [
  ExchangeDollarToIQDPipe,
  ExchangeIQDToDollarPipe,
  CurrencySignPipe,
];
@NgModule({
  imports: [CommonModule, ...NB_MODULES],
  exports: [CommonModule, ...PIPES, ...COMPONENTS],
  declarations: [...COMPONENTS, ...PIPES],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: "dark",
          },
          [DARK_THEME],
          DEFAULT_MEDIA_BREAKPOINTS,
          NbLayoutDirection.RTL
        ).providers,
      ],
    };
  }
}
